// BT-1452: `info` is undefined when the Firestore user doc doesn't exist yet
// or the bootstrap degrades after exhausting retries — tolerate it instead
// of throwing, so auth bootstrap can always produce a usable user.
const firebaseUser = (user, info) => ({
  name: user.displayName,
  email: user.email,
  uid: user.uid,
  role: info?.type,
});

export default firebaseUser;
